// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前用户信息 GET /bff/auth/profile */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUser>('/bff/auth/profile', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 刷新访问令牌 POST /bff/auth/refreshToken */
export async function refreshToken(refreshToken: string, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/bff/auth/refreshToken', {
    method: 'POST',
    params: {
      refreshToken,
    },
    ...(options || {}),
  });
}

/** 用户注册 POST /bff/auth/register（注册后返回 token） */
export async function register(body: API.RegisterParams, options?: { [key: string]: any }) {
  return request<API.RegisterResult>('/bff/auth/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 企业注册：创建企业 POST /bff/auth/create-tenant */
export async function createTenant(
  body: { tenantName: string } & API.EnterpriseBindingParams,
  options?: { [key: string]: any },
) {
  return request<API.CreateTenantResult>('/bff/auth/create-tenant', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 企业注册：通过企业编码加入企业 POST /bff/auth/join-tenant-by-code */
export async function joinTenantByCode(
  body: { tenantCode: string } & API.EnterpriseBindingParams,
  options?: { [key: string]: any },
) {
  return request<{ tenantUuid: string; organizationUuid: string; message: string }>(
    '/bff/auth/join-tenant-by-code',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 发送短信验证码 POST /bff/auth/sendSmsCode */
export async function sendSmsCode(
  body: { phone: string; phoneCountryCode?: string; scene?: string },
  options?: { [key: string]: any },
) {
  return request<{ message: string }>('/bff/auth/sendSmsCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 验证短信验证码 POST /bff/auth/verifySmsCode */
export async function verifySmsCode(
  body: { phone: string; smsCode: string; phoneCountryCode?: string },
  options?: { [key: string]: any },
) {
  return request<{ message: string; registered?: boolean }>('/bff/auth/verifySmsCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据租户编码查询租户 GET /bff/auth/tenant-by-code */
export async function getTenantByCode(code: string, options?: { [key: string]: any }) {
  return request<API.TenantLookupResult>('/bff/auth/tenant-by-code', {
    method: 'GET',
    params: { code },
    ...(options || {}),
  });
}

/** 获取当前用户的企业列表（从 IAM 查询） GET /bff/auth/tenant-list */
export async function getTenantList(options?: { [key: string]: unknown }) {
  return request<
    Array<{
      id: string;
      name: string;
      code?: string;
      logo?: string;
      description?: string;
      organizations?: Array<{
        orgId: string;
        name: string;
        code?: string;
      }>;
      roleLabel?: '管理员' | '成员';
    }>
  >('/bff/auth/tenant-list', {
    method: 'GET',
    ...(options || {}),
  });
}
